export default __webpack_public_path__ + "static/media/tsb.1182176a.png";